<template>
  <div class="legend-container caption">
    <div v-for="item in items" :key="item.key" class="legend-item">
      <div
        :class="`legend-swatch legend-swatch--${item.shape}`"
        :style="{ background: item.color }"
      ></div>
      <div class="legend-label">{{ item.key }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartLegend",
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.legend-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.legend-item {
  margin: 4px 12px;
  display: flex;
  align-items: center;
}

.legend-swatch {
  margin-right: 8px;
}

.legend-swatch--square {
  width: 16px;
  height: 16px;
}

.legend-swatch--line {
  width: 32px;
  height: 2px;
}
</style>
